import { render, staticRenderFns } from "./singleSignOnList.vue?vue&type=template&id=b101f3ac&"
import script from "./singleSignOnList.vue?vue&type=script&lang=js&"
export * from "./singleSignOnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports